// Croqui: `components/Divider.tsx`.

import { cn } from '../../lib/cn.ts';

/** Linha de 1px na cor da borda. `vertical` separa colunas. */
export function Divider({
  vertical = false,
  className,
}: {
  vertical?: boolean;
  className?: string;
}) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'bg-border',
        vertical ? 'w-px shrink-0 self-stretch' : 'h-px w-full',
        className,
      )}
    />
  );
}
